export const functionalities_data = {
    'es': [
        {
            'title' : 'Certificación',
            'desc'  : 'Nuestra plataforma posibilita la generación de certificados de aprobación de los cursos. Esta certificación puede ser gratuita o de pago.'
        },
        {
            'title' : 'Compatibilidad con estándar SCORM',
            'desc'  : 'SCORM (Shareable Content Object Reference Model) es un conjunto de objetos de aprendizaje empaquetados y estructurados como material web de forma pedagógica bajo un estándar libre que permite importar, reutilizar y compartir contenidos. Nuestra plataforma acepta este tipo de objetos y permite la evaluación a través de ellos.'
        },
        {
            'title' : 'Compatibilidad con estándar LTI 1 & 2',
            'desc'  : 'LTI (Learning Tools Interoperability), es un estándar de comunicación entre herramientas y sistemas de aprendizaje e-learning. Nuestra plataforma es compatible con este estándar, permitiendo a los docentes integrarse con aplicaciones externas que soporten este estándar.'
        },
        {
            'title' : 'Preguntas en videos',
            'desc'  : 'Esta funcionalidad permite insertar preguntas en momentos específicos de un video.'
        },
        {
            'title' : 'Evaluación de discusiones',
            'desc'  : 'Esta funcionalidad permite al equipo docente evaluar la participación de los estudiantes en las discusiones/foros de los cursos.'
        },
        {
            'title' : 'Módulo de seguimiento',
            'desc'  : 'Seguimiento en tiempo real de los avances de los estudiantes de un curso, visualizando las secciones/unidades visualizadas y completadas por los usuarios.'
        },
        {
            'title' : 'Visor de imágenes de alta resolución',
            'desc'  : 'Este componente permite visualizar imaganes de alta resolución, en el cual los estudiantes pueden realizar anotaciones/comentarios para posteriormente ser evaluadas por el equipo docente. Esto es gracias a la integracion con Annotorious y OpenSeaDragon, el primero nos permite realizar las anotaciones y el segundo permite la visualizacion de imagenes de alta resolucion.'
        },
        {
            'title' : 'U-Cursos',
            'desc'  : 'Es posible integrar nuestra plataforma a los cursos que se imparten a través de U-Cursos.'
        },
        {
            'title' : 'Cuenta Pasaporte UChile.',
            'desc'  : 'Nuestra plataforma se integra con la Cuenta Pasaporte UChile, permitiendo el inicio de sesión a través de ésta.'
        },
        {
            'title' : 'Google Docs',
            'desc'  : 'Inserta archivos de Google Drive en tu curso. Puedes compartir: Google Docs, Google Drawings, Google Forms, Google Slides & Google Sheets.'
        },
        {
            'title' : 'Youtube',
            'desc'  : 'Incluye videos de Youtube en tus clases. Nuestra plataforma, además de permitir la visualización de estos videos, permite agregar transcripciones para una mayor accesibilidad del contenido de tus cursos.'
        },
        {
            'title' : 'Vimeo',
            'desc'  : 'Permite la subida de videos a la plataforma Vimeo. Los videos no cuentan con publicidad y solamente pueden ser incrustrados en nuestra plataforma.'
        },
        {
            'title' : 'Zoom',
            'desc'  : 'Nuestra plataforma se integra con la herramienta Zoom para videollamadas. Crea y configura tus clases y reuniones a través de nuestra plataforma. Puedes restringir el acceso a tus videollamadas únicamente a los estudiantes inscritos en el curso, transmitir en Youtube, etc.'
        },
        {
            'title' : 'Sence',
            'desc'  : 'Nuestra plataforma permite la realización de cursos y capacitaciones Sence.'
        },
        {
            'title' : 'Sistemas de pago Webpay/Paypal',
            'desc'  : 'Existen cursos que requieren un pago previo para la inscripción o la emisión de certificados. Para esto, nuestra plataforma se ha integrado con sistemas de pago nacional (Webpay) e internacional (Paypal).'
        },
    ]
}
